export const SHOULD_BE_CLOSED_COOKIE = 'outdatedBrowserClosed';
export const TEST_OUTDATED_BROWSER_INFO_QUERY_PARAM = 'testOutdatedBrowserInfo';
